import {getLocalDateTime} from "../../../../core/dateUtils";

export default function sendImmediateToggle() {
    return {
        immediate: false,
        savedDate: '',
        showPastWarning: false,
        init() {
            const input = this.$refs.dateInput;
            this.immediate = !input.value;
            if (!this.immediate) {
                this._checkPastWarning(input.value);
            }
        },
        onToggle() {
            const input = this.$refs.dateInput;
            if (this.immediate) {
                this.savedDate = input.value;
                input.value = '';
                this.showPastWarning = false;
            } else {
                input.value = this.savedDate;
                if(!input.value)
                    input.value = getLocalDateTime();
                this._checkPastWarning(input.value);
            }
        },
        onDateChange(value) {
            if (value) {
                this.immediate = false;
            }
            this._checkPastWarning(value);
        },
        _checkPastWarning(value) {
            this.showPastWarning = !!value && new Date(value) < new Date();
        }
    };
}
